var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 38,
    viewBox: "0 0 51 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5557_42379)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.675781,
    y: 0.911133,
    width: 50,
    height: 37,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.675781 0.911133H10.1996V10.7778H0.675781V0.911133ZM14.9615 0.911133H24.4853V10.7778H14.9615V0.911133ZM0.675781 15.7111H10.1996V25.5778H0.675781V15.7111ZM14.9615 15.7111H24.4853V25.5778H14.9615V15.7111ZM24.4853 0.911133H50.6758V5.84447H24.4853V0.911133ZM24.4853 10.7778H50.6758V15.7111H24.4853V10.7778Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.675781 20.6445H50.6758V25.5779H0.675781V20.6445ZM10.1996 20.6445H14.9615V25.5779H10.1996V20.6445ZM0.675781 30.5112H50.6758V35.4445H0.675781V30.5112Z",
    fill: "#1A47B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5557_42379"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.675781,
    y: 0.911133,
    width: 50,
    height: 37,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/Greece.35f8cd252185251c30609dac93fc5e6c.svg";
export { ForwardRef as ReactComponent };